module.exports = __webpack_public_path__ + "static/media/29DUNON14.217cfc88.jpg";